// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e330a07c","122":"fea19c40","534":"e80b216b","665":"b7d972d9","781":"dbd8d426"}[chunkId] + ".chunk.js";
};